import { DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-price',
  imports: [DecimalPipe],
  templateUrl: './price.html',
  styleUrl: './price.scss',
})
export class Price {
  @Input({ required: true }) price: number = 0;
}
